<template>
  <div id="datatable">
    <div v-if="hasSearchPower">
      <form class="form-inline pull-right" v-if="$route.name !== 'ItemBank'">
        <div class="form-group m-r-10" v-if="filterCriteria.length > 0">
          <span class="label label-info m-r-5" v-for="(criteria, index) in filterCriteria" v-bind:key="index">{{ criteria }}</span>
        </div>
        <div class="form-group m-r-10">
          <input type="text" class="form-control" placeholder="Kata kunci" v-model="query">
        </div>
        <div class="form-group m-r-10">
          <select class="form-control" v-model="field">
            <option v-for="(value, key) in headers" :value="key" v-bind:key="key">{{ value }}</option>
          </select>
        </div>
        <div class="form-group m-r-10">
          <button type="button" class="btn btn-white" @click="doFilter()">Filter</button>
        </div>
        <div class="form-group m-r-10">
          <button type="button" class="btn btn-white" @click="clearFilter()">Hapus Filter</button>
        </div>
        <div class="form-group m-r-10">
          <select class="form-control" :value="orderBy" v-on:change="updateOrderBy">
            <option value="desc">Baru ke Lama</option>
            <option value="asc">Lama ke Baru</option>
          </select>
        </div>
      </form>
    </div>

    <div class="hasfilterstatus" v-if="hasFilterStatus">
      <div class="flex-disp">
        <div class="flex-disp" @click="filterByStatus(null)">
          <div :id="disableStatus === null ? 'tabstatus-active' : 'tabstatus'" >
          ALL
          </div>
          <div :id="disableStatus === null ? 'tabtriangle-active' : 'tabtriangle'">
          </div>
        </div>
        <div class="flex-disp" @click="filterByStatus('CHECKOUT')">
          <div :id="disableStatus === 'CHECKOUT' ? 'tabstatus-active' : 'tabstatus'" >
          Checkout
          </div>
          <div :id="disableStatus === 'CHECKOUT' ? 'tabtriangle-active' : 'tabtriangle'">
          </div>
        </div>
        <div class="flex-disp" @click="filterByStatus('CONFIRMED')">
          <div :id="disableStatus === 'CONFIRMED' ? 'tabstatus-active' : 'tabstatus'" >
          Confirmed
          </div>
          <div :id="disableStatus === 'CONFIRMED' ? 'tabtriangle-active' : 'tabtriangle'">
          </div>
        </div>
        <div class="flex-disp" @click="filterByStatus('ACTIVATED')">
          <div :id="disableStatus === 'ACTIVATED' ? 'tabstatus-active' : 'tabstatus'" >
          Activated
          </div>
          <div :id="disableStatus === 'ACTIVATED' ? 'tabtriangle-active' : 'tabtriangle'">
          </div>
        </div>
        <div class="flex-disp" @click="filterByStatus('REJECTED')">
          <div :id="disableStatus === 'REJECTED' ? 'tabstatus-active' : 'tabstatus'" >
          Rejected
          </div>
          <div :id="disableStatus === 'REJECTED' ? 'tabtriangle-active' : 'tabtriangle'">
          </div>
        </div>
        <div class="flex-disp" @click="filterByStatus('EXPIRED')">
          <div :id="disableStatus === 'EXPIRED' ? 'tabstatus-active' : 'tabstatus'" >
          Expired
          </div>
          <div :id="disableStatus === 'EXPIRED' ? 'tabtriangle-active' : 'tabtriangle'">
          </div>
        </div>
        <div class="flex-disp" @click="filterByStatus('REFUND')">
          <div :id="disableStatus === 'REFUND' ? 'tabstatus-active' : 'tabstatus'" >
          Refund
          </div>
          <div :id="disableStatus === 'REFUND' ? 'tabtriangle-active' : 'tabtriangle'">
          </div>
        </div>
        <div class="flex-disp" @click="filterByStatus('CANCELED')">
          <div :id="disableStatus === 'CANCELED' ? 'tabstatus-active' : 'tabstatus'" >
          Canceled
          </div>
          <div :id="disableStatus === 'CANCELED' ? 'tabtriangle-active' : 'tabtriangle'">
          </div>
        </div>
      </div>
    </div>
    <table class="table table-hover">
      <thead>
        <tr>
          <th v-if="hasCheckbox"><input type="checkbox" v-model="selectAll" @click="checkboxSelectAll()" value="All"/></th>
          <th>No.</th>
          <th v-for="(header, index) in headers" v-bind:key="index">{{ header }}</th>
          <th v-if="hasAction || hasExport">Action</th>

          <th v-if="hasPaymentStatus">Status</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(values, key) in currentPageItems" @dblclick="selectRowAndFinish(key)" 
          @click="selectRow(key)" v-bind:class="{'success': selectedRow == key}" v-bind:key="key">
          <td v-if="hasCheckbox"> <input type="checkbox" :value="values.id" v-model="selectedCheckbox"/> </td>
          <td>{{ startNumber + key + 1 }}</td>
          <td v-for="(value, index) in values.data" v-bind:key="index" :class="hasSoldoutWarning && values.data[2] < 50 ? 'sold-out' : ''" style="word-break:break-all;">
            <!-- <span v-if="index === 9 && value===false"><i class="fa fa-check"></i></span>
            <span v-if="index === 9 && value===true">-</span> -->
            <span v-html="value">{{index}}</span>
          </td>
          <td v-if="hasPaymentStatus">
            <div v-for="(values, index) in values.status" v-bind:key="index">
              <span
                class="label"
                :class="{
                  'label-warning': (values === 'CHECKOUT'),
                  'label-primary': (values === 'CONFIRMED'),
                  'label-danger': (values === 'EXPIRED' || values === 'REJECTED' || values === 'CANCELED'),
                  'label-success': (values === 'ACTIVATED'),
                  'label-default': (values === 'REFUND')
                }"
                style="font-size: 0.9em"
              >
                {{ values }}
              </span>
            </div>
          </td>
          <td v-if="values.actions">
            <button v-for="action in values.actions" v-bind:key="action.command"
              @click="$emit(action.command, selectRow(key))"
              :class="action.style"
              class="btn btn-xs btn-edit m-1">{{action.text}}</button>
          </td>
          <td v-if="hasAction" style="display:flex; flex-flow:row; justify-content:flex-start;align-items:baseline;">
            <button v-if="hasGrading" class="btn btn-info btn-xs btn-edit m-1" @click="$emit('gradingTryout', selectRow(key))">Grading</button>
            <button v-if="hasRanking" class="btn btn-primary btn-xs btn-edit m-1" @click="$emit('rankingTryout', selectRow(key))">Top 10</button>
            <button v-if="hasEdit" class="btn btn-primary btn-xs btn-edit m-1" @click="editItem(key)">Edit</button>
            <button v-if="hasEditA" class="btn btn-primary btn-xs btn-edit m-1" @click="editItemContent(key)">Edit</button>
            <button v-if="hasPreview" class="btn btn-primary btn-xs btn-preview m-1" data-toggle="modal" data-target=".bd-example-modal-sm" @click="previewVideo(values)">Preview</button>
            <button v-if="hasPublish && values.status === 'DRAFT'" class="btn btn-success btn-xs btn-preview m-1"  @click="publishing(values)">Publish</button>
            <button v-if="hasPublish && values.status === 'HIDDEN'" class="btn btn-success btn-xs btn-preview m-1"  @click="publishing(values)">Publish</button>
            <button v-if="hasPublish && values.status === 'PUBLISHED'" class="btn btn-danger btn-xs btn-preview m-1" @click="unpublishing(values)">Unpublish</button>
            <button v-if="hasDelete" class="btn btn-danger btn-xs m-1" @click="deleteItem(key)">Hapus</button>
            <button v-if="hasAddQuota" :class="hasSoldoutWarning && values.data[2] < 50 ? 'btn btn-danger btn-xs m-1' : 'btn btn-success btn-xs m-1'" @click="$emit('addQuota', values)">Tambah Kuota</button>
            <div v-if="hasPreview" class="modal fade bd-example-modal-sm" tabindex="-1" role="dialog" aria-labelledby="mySmallModalLabel" aria-hidden="true">
              <div class="modal-dialog modal-sm">
                <div class="modal-content">
                  <youtube :video-id="videoId" ref="youtube" @playing="playing"></youtube>
                </div>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <div v-if="$route.name !== 'ItemBank' && $route.name !== 'FreeItemBank' ">
      <div class="btn-group pull-left" v-if="hasSearchPower">
        <button class="btn btn-white" type="button">Total Page:</button>
        <button class="btn btn-white" type="button">{{ this.maxPage }}</button>
      </div>
      <div class="btn-group pull-right" v-if="items.length > 0 && hasSearchPower">
        <button class="btn btn-white" type="button" v-on:click="goToPage(currentPage-1)">
          Previous
        </button>
        <input type="number" v-model="currentPage" min="1" :max="maxPage">
        <button v-if="currentPage < maxPage" class="btn btn-white" type="button" v-on:click="goToPage(currentPage+1)">
          Next
        </button>
      </div>
    </div>
  </div>
</template>
<style scoped>
.btn-edit {
  margin-bottom: 5px;
}
.btn-preview {
  margin-top: 5px;
}
.flex-disp {
  display:flex;
}

.hasfilterstatus {
  float:left; margin-top:20px;width:100%;border-bottom: 1px solid lightgrey;
}

#tabstatus {
  background:white;
  height:35px;
  align-items:center;
  display:flex;
  padding:10px;
  min-width:60px;
  justify-content: center;
  cursor: pointer;
}
#tabtriangle {
  width: 0;
  height: 0;
  border-bottom: 35px solid white;
  border-right: 25px solid transparent;
  cursor: pointer;
}
#tabstatus-active {
  background:lightgray;
  height:35px;
  align-items:center;
  display:flex;
  padding:10px;
  min-width:60px;
  justify-content: center;
  color:#348fe2;
  border-top-left-radius: 5px;
  cursor: pointer;
}
#tabtriangle-active {
  width: 0;
  height: 0;
  border-bottom: 35px solid lightgrey;
  color:#348fe2;
  border-right: 25px solid transparent;
  cursor: pointer;
}

.sold-out {
  font-weight: bold;
  color: red;
}
</style>
<script>
export default {
  name: "datatable",
  props: {
    items: { type: Array, default: [] },
    headers: { type: Array, default: [] },
    hasAction: { type: Boolean, default: true },
    hasExport: { type: Boolean, default: false },
    hasGenerate: { type: Boolean, default: false },
    hasPreview: { type: Boolean, default: false },
    hasPublish: { type: Boolean, default: false },
    hasCheckbox: { type: Boolean, default: false },
    hasPaymentStatus: { type: Boolean, default: false },
    hasDelete: { type: Boolean, default: true },
    hasAddQuota: { type: Boolean, default: false },
    hasGrading: { type: Boolean, default: false },
    hasRanking: { type: Boolean, default: false },
    hasCustomPagination: { type: Boolean, default: false },
    hasCustomSearch: { type: Boolean, default: false },
    hasEdit: { type: Boolean, default: false },
    hasSoldoutWarning : { type: Boolean, default: false },
    hasEditA: { type: Boolean, default: false },
    hasFilterStatus : { type: Boolean, default: false },
    hasSearchPower : { type: Boolean, default: true },
    persistFilter: { type: Boolean, default: true },
    currentPageProp: { type: Number, default: 1 },
    customPaginationCurrentPage: { type: Number, default: 1 },
    customPaginationPerPage: { type: Number, default: 0 },
    customPaginationTotalItems: { type: Number, default: 0 },
    customPaginationTotalPages: { type: Number, default: 0 },
    customPaginationSortMode: { type: String, default: "desc" }
  },
  data: function () {
    return {
      currentPageItems: [],
      selectedRow: -1,
      filteredItems: [],
      query: null,
      field: null,
      videoId: null,
      disableStatus: null,
      selectedCheckbox: [],
      selectAll: false
    };
  },
  computed: {
    player() {
      return this.$refs.youtube.player
    },
    currentPage: {
      get: function () {
        if (this.hasCustomPagination) {
          return this.customPaginationCurrentPage
        }

        return parseInt(this.$store.state.datatable.currentPage)
      },
      set: function (val) {
        if (this.hasCustomPagination) {
          this.goToPage(val)
        } else {
          this.$store.commit('datatable_currentPage', val)
        }
      }
    },
    pageStart: function () {
      return this.$store.state.datatable.pageStart
    },
    pageSize: function () {
      return this.customPaginationPerPage || this.$store.state.datatable.pageSize
    },
    pageEnd: function () {
      return this.$store.state.datatable.pageEnd
    },
    orderBy: function () {
      if (this.hasCustomPagination) return this.customPaginationSortMode
      return this.$store.state.datatable.orderBy
    },
    maxPage: function () {
      return this.hasCustomPagination
        ? this.customPaginationTotalPages
          ? this.customPaginationTotalPages
          : Math.ceil(this.customPaginationTotalItems / this.pageSize)
        : Math.ceil(this.filteredItems.length / this.pageSize)
    },
    startNumber() {
      if (this.$route.name === 'ItemBank' || this.$route.name === 'FreeItemBank') {
        return (this.currentPageProp - 1) * this.pageSize;
      } else {
        return (this.currentPage - 1) * this.pageSize;
      }
    },
    filterCriteria: function () {
      var result = []
      var filters = []
      if (this.persistFilter) filters = this.$store.state.datatable.filter

      for (var i = 0; i < filters.length; i++) {
        var filter = filters[i];
        var criteria = this.headers[filter.key] + " = " + filter.value;
        result.push(criteria);
      }

      return result;
    }
  },
  methods: {
    filterByStatus: function(val) {
      this.disableStatus = val
      this.$emit("filterByStatus", val)
    },
    updateOrderBy: function (e) {
      if (this.hasCustomPagination) this.$emit('changeSortMode', e.target.value)
      else this.$store.commit('datatable_orderby', e.target.value)
    },
    goToPage: function (page) {
      if (page > 0 && page <= this.maxPage) {
        if (this.hasCustomPagination) this.$emit('changePage', page)
        else this.$store.commit('datatable_currentPage', page)
      } else if (page > this.maxPage) {
        alert('Data hanya sampai ' + this.maxPage + ' Halaman')
      }
    },
    publishing(item) {
      this.$emit("publishing", item);
    },
    unpublishing(item) {
      this.$emit("unpublishing", item);
    },
    getItemsInPage: function (page) {
      page = (this.hasCustomPagination) ? 1 : page
      var start = (page - 1) * this.pageSize;
      var end = start + this.pageSize;

      if (end > this.filteredItems.length - 1) {
        return this.filteredItems.slice(start);
      }

      return this.filteredItems.slice(start, end);
    },
    deleteItem: function (index) {
      var realIndex = index + (this.currentPage - 1) * this.pageSize;
      var selectedRow = (this.hasCustomPagination) ? this.selectRow(index) : this.filteredItems[realIndex];
      this.$emit("deleted", selectedRow);
    },
    previewVideo: function (index) {
      if (index.url.indexOf('embed') > -1) {
        this.videoId = index.url.split('/')[4]
      } else {
        this.videoId = index.url.substring(index.url.indexOf('=') + 1);
      }
    },
    selectRow: function (index) {
      var realIndex = (this.hasCustomPagination) ? index : index + (this.currentPage - 1) * this.pageSize;
      var selectedRow = this.filteredItems[realIndex];
      this.$emit("selected", selectedRow);

      return selectedRow
    },
    selectRowAndFinish(index) {
      var selectedRow = this.selectRow(index)
      this.$emit("dblClicked", selectedRow);
    },
    editItem(index) {
      var realIndex = index;
      if (!this.hasCustomPagination) realIndex = index + (this.currentPage - 1) * this.pageSize;

      var selectedRow = this.filteredItems[realIndex];
      this.$emit("editNewTab", selectedRow);
    },
    editItemContent(index) {
      var selectedRow = this.selectRow(index)
      this.$emit("editNewTab", selectedRow);
    },
    doFilter: function () {
      if (this.field != null) {
        this.query = this.query !== null ? this.query.trim() : "";
        var criteria = { key: this.field, value: this.query }

        if (this.hasCustomSearch) {
          this.goToPage(1)
          this.$emit("doSearch", criteria)
        } else {
          this.$store.commit('datatable_push_filter', criteria);
          var filters = this.$store.state.datatable.filter;

          for (var i = 0; i < filters.length; i++) {
            var filter = filters[i];
            this.doBasicFilter(filter);
          }

          this.query = null;
          this.field = null;
        }
      }
    },
    doBasicFilter: function (filter) {
      var context = this
      var result = this.filteredItems.filter(function (item) {
        if (!item.data[filter.key]) return false

        var index = item.data[filter.key]
          .toLowerCase()
          .indexOf(filter.value.toLowerCase())
        return index > -1
      })

      this.filteredItems = result
    },
    clearFilter: function () {
      this.query = null;
      this.field = null;
      this.filteredItems = this.items;
      this.$store.commit('datatable_pageStart', 1);
      this.$store.commit('datatable_pageEnd', 10);
      this.$store.commit('datatable_clear_filter');
      if (this.hasCustomSearch) {
        this.goToPage(1)
        this.$emit('doSearch', { value: null, key: null })
      }
    },
    doOrder: function () {
      var tmp = this.filteredItems.slice(0);
      if (this.$store.state.datatable.orderBy == 'asc') {
        tmp.sort(function (a, b) {
          return a.id - b.id;
        })
      } else {
        tmp.sort(function (a, b) {
          return b.id - a.id;
        })
      }

      this.filteredItems = tmp;
    },
    playVideo() {
      this.player.playVideo()
    },
    playing() {
      console.log('\o/ we are watching!!!')
    },
    checkboxSelectAll() {
      this.selectedCheckbox = this.$store.state.tryout.selectedTO
			if (!this.selectAll) {
        this.unselectAtPage()
				for (let i in this.items) {
					this.selectedCheckbox.push(this.currentPageItems[i].id);
				}
			} else {
        this.unselectAtPage()
      }
    },
    unselectAtPage(){
      for (var i = 0; i < this.items.length; i++) {
					var finding = this.selectedCheckbox.find(element => {
            return parseInt(element) == parseInt(this.items[i].id)
          })
          if(finding){
            var index = this.selectedCheckbox.indexOf(finding);
            if (index !== -1) {
              this.selectedCheckbox.splice(index, 1);
            }
          }
        }
    },
    checkIsAll: function () {
      for (var i = 0; i < this.items.length; i++) {
					var finding = this.selectedCheckbox.find(element => {
            return parseInt(element) == parseInt(this.items[i].id)
          })
          if(!finding){
            return false
          }
      }
      return true
    }
  },
  watch: {
    currentPage: function (page) {
      this.currentPageItems = this.getItemsInPage(page)
      this.selectedCheckbox = this.$store.state.tryout.selectedTO
    },
    selectedCheckbox: function(to,from){
      this.$store.commit('tryoutSelected', to)
    },
    items: function (val) {
      this.filteredItems = val;
      var fullPath = this.$route.fullPath;
      var datatableContext = this.$store.state.datatable.context;
      if (fullPath == datatableContext) {
        var filters = this.$store.state.datatable.filter;
        for (var i = 0; i < filters.length; i++) {
          var filter = filters[i];
          this.doBasicFilter(filter);
        }
      } else {
        this.$store.commit('datatable_context', fullPath)
        this.clearFilter();
      }

      this.selectAll = this.checkIsAll()
      // console.log(this.checkIsAll())
    },
    filteredItems: function (val) {
      this.$store.commit('datatable_currentPage', 1)
      this.currentPageItems = this.getItemsInPage(this.currentPage);
    },
    orderBy: function (val) {
      this.$store.commit('datatable_orderby', val);
      this.doOrder();
    }
  },
  mounted: function () {
    this.filteredItems = this.items
    this.currentPageItems = this.getItemsInPage(1)
  }
};
</script>



// WEBPACK FOOTER //
// DataTable.vue?0810d2c6